import { useRootPlaceBySlugQuery } from '~/libs/gql/queries/root_places/rootPlaceBySlugQuery.generated';

type UseRootPlaceBySlugDataArgs = {
  limit: number
  offset: number
  rootDishCategorySlug?: string | null
  slug: string
  sortBy: string
  sortDir: string
}

export const useRootPlaceBySlugData = ({ limit, offset, rootDishCategorySlug = null, slug, sortBy, sortDir }: UseRootPlaceBySlugDataArgs) => {
  const query = useRootPlaceBySlugQuery({
    variables: {
      pagination: {
        limit,
        offset,
        sortBy,
        sortDir,
      },
      rootDishCategorySlug,
      slug,
    },
  });
  return query;
};
